/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData } from "utils/Gateway";

import ProcessModuleOptions from "data/Prod/ProcessModuleOptions.json";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const AddProcessFromTemplateModal = ({
  afterProcessModalClose,
  moduleSlug = "",
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const [followersInput, setFollowersInput] = useState("");
  const [folowersOptions, setFollowersOptions] = useState([]);

  const [processList, setprocessList] = useState([]);
  const [processIndex, setProcessIndex] = useState(null);
  const [processData, setProcessData] = useState(null);

  const [followersValue, setfollowersValue] = useState(null);
  const [selectedFollowers, setselectedFollowers] = useState([]);
  const [moduleValue, setmoduleValue] = useState(null);
  const [selectedModule, setSelectedModule] = useState("");

  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setFollowersOptions(response.data);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //get all process templates
  const getAllProcess = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_PROCESS +
        `?istemplate=${true}`;

      const response = await getData(requestURL);

      if (response.status) {
        //update list for react select
        const updatedProcessList = response.data.map((item, index) => {
          return {
            ...item,
            label: item.title,
            value: item._id,
          };
        });

        //display last process by default
        if (updatedProcessList.length > 0) {
          processSelectionHandler(updatedProcessList[0], 0);
        }

        setprocessList(updatedProcessList);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select process
  const processSelectionHandler = (processItem, index) => {
    seterrorMessage("");
    setProcessIndex(index);
    setProcessData(processItem);
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setfollowersValue(val);
    setselectedFollowers(val.map((item) => item.value));
  };

  //select module
  const moduleSelectionHandler = (val) => {
    seterrorMessage(""); // Clear error message on change
    if (val) {
      setmoduleValue(val);
      setSelectedModule(val.value);
    } else {
      setmoduleValue(null);
      setSelectedModule("");
    }
  };

  //save process
  const saveProcessHandler = async () => {
    // --- Client-side validation ---
    if (!processData) {
      seterrorMessage("Please select a template from the list to continue.");
      return;
    }
    if (moduleSlug === "" && !selectedModule) {
      seterrorMessage("A module must be selected before saving the process.");
      return;
    }

    seterrorMessage("");
    setIsSaving(true);

    try {
      //send tagids as array and component order id as null
      const processTagIds = processData.processtagids.map((item) => ({
        tagid: item,
        componentorderid: null,
      }));

      const processTemplateData = {
        title: processData.title,
        slug: processData.slug.toUpperCase(),
        moduleslug: moduleSlug === "" ? selectedModule : moduleSlug,
        istemplate: false,
        tags: processTagIds,
        followers: selectedFollowers,
      };

      let requestURL =
        url.API_BASE_URL + url.API_ADD_NEW_PROCESS;
      const response = await postData(requestURL, processTemplateData);

      setIsSaving(false);

      if (response.status) {
        resetModal();
        // close the modal of addLabel
        let templateModal = document.querySelector("#kanbanExample");
        let modal = bootstrap.Modal.getInstance(templateModal);
        modal.hide();
        afterProcessModalClose(response.data);
      } else {
        seterrorMessage(response.message || "An unexpected error occurred.");
      }
    } catch (error) {
      setIsSaving(false);
      seterrorMessage(error.message || "Failed to save the process.");
      console.log(error.message);
    }
  };

  const resetModal = () => {
    setfollowersValue(null);
    setselectedFollowers([]);
    setmoduleValue(null);
    setSelectedModule("");
    seterrorMessage("");
    getAllProcess();
  };

  useEffect(() => {
    getAllProcess();
  }, []);

  useEffect(() => {
    if (followersInput.length > 1) {
      // Fetch only after 2 characters
      const timer = setTimeout(() => {
        getFollowersList();
      }, 500); // Debounce API call
      return () => clearTimeout(timer);
    }
  }, [followersInput]);

  const followersOptionsToShow =
    folowersOptions.length > 0 ? folowersOptions : [];

  const isSaveDisabled =
    isSaving || !processData || (moduleSlug === "" && !selectedModule);

  return (
    <div
      className="modal fade placeholder-glow"
      id="kanbanExample"
      tabIndex="-1"
      aria-labelledby="kanbanExampleLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  add_box
                </span>
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="kanbanExampleLabel"
                >
                  {t("Add Process from Template")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t(
                    "Select a template to create a new process for your kanban project."
                  )}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetModal}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <div className="row gx-5">
                <div
                  className="col-lg-3 d-none d-lg-block ps-0 overflow-y-auto"
                  style={{ height: "20rem" }}
                >
                  <ul className="menu fw-semibold ps-1">
                    {processList.map((processItem, index) => {
                      return (
                        <li
                          className={processIndex === index ? "active" : ""}
                          key={index}
                        >
                          <Link
                            to="#"
                            className="d-block"
                            onClick={() => {
                              processSelectionHandler(processItem, index);
                            }}
                          >
                            {processItem.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="col-lg-9">
                  <div className="form-group d-block d-lg-none mb-4">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Select a Template")}
                    </label>
                    <Select
                      placeholder={t("Choose a process template...")}
                      options={processList}
                      value={processData}
                      onChange={(val) => {
                        processSelectionHandler(val);
                      }}
                    />
                  </div>

                  {processData && (
                    <div className="p-3 bg-light rounded-3 border">
                      <h4 className="fw-semibold fs-lg mb-3">
                        {t("Template Preview")}
                      </h4>
                      <ul className="example row justify-content-center fw-semibold mt-4">
                        {processData.processlabels.map((item, index) => {
                          return (
                            <li
                              className="col-4 col-sm-auto mb-3 mb-xl-0"
                              key={index}
                            >
                              <p className="mb-3 text-center">{item}</p>
                              <img
                                src={assetImages.deliveredImg}
                                alt="Process Step Illustration"
                                className="img-fluid"
                              />
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              <hr className="my-4" />

              {/* <!-- ========== Start Followers & Module Section ========== --> */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="followers-select"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Add Followers (Optional)")}
                    </label>
                    <Select
                      menuPlacement="top"
                      inputId="followers-select"
                      isMulti
                      placeholder={t("Search by name or email...")}
                      options={followersOptionsToShow}
                      value={followersValue}
                      onChange={(val) => followersSelectionHandler(val)}
                      onInputChange={(val) => {
                        followersInputHandler(val);
                      }}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                </div>

                {moduleSlug === "" && (
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label
                        htmlFor="module-select"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Select Module")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        menuPlacement="top"
                        inputId="module-select"
                        isClearable
                        placeholder={t("Choose a module for the process...")}
                        options={ProcessModuleOptions}
                        value={moduleValue}
                        onChange={(val) => moduleSelectionHandler(val)}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* <!-- ========== End Followers & Module Section ========== --> */}
            </div>
          </div>
          <div className="modal-footer p-4 d-flex justify-content-between align-items-center border-top">
            {errorMessage && (
              <div className="validation-error d-flex align-items-center gap-2 fs-md text-primary">
                <span className="d-block material-symbols-outlined icon-md">
                  info
                </span>
                <span className="d-block">{errorMessage}</span>
              </div>
            )}
            <div className="action d-flex justify-content-between gap-3 ms-auto">
              <button
                onClick={saveProcessHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaveDisabled}
                style={{
                  cursor: isSaveDisabled ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Use This for My Project")}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProcessFromTemplateModal;
